module.exports = __webpack_public_path__ + "img/svg/background-login-mobile.35273eb5fe8b42a4743ac5c985a88d5c.svg";